import React from "react";

export function LegalInfo({ className = "" }) {
  return (
    <div className={`text-[14px] leading-relaxed text-[#6E6B65] text-center py-6 px-4 break-words ${className}`} data-testid="legal-info">
      <p>MDS – MED SRL – P.IVA 11999300962 – REA: MB 2633857</p>
      <p>Sede legale: Largo Repubblica 7, 20854 Vedano al Lambro (MB)</p>
      <p>
        Contatti:{" "}
        <a href="mailto:info@riseyourlife.it" className="text-[#B5651D] hover:underline" data-testid="legal-info-email">info@riseyourlife.it</a>
      </p>
    </div>
  );
}
